import { AddressInformationFragment, AddressNameFragment, CountryNameFragment } from "../../../Utilities";
import * as CountryFormat from "../Country";
import * as Fields from "./fields";

export { Fields };

/**
 * Formats the full name of the given instance.
 */
export function name(instance: AddressNameFragment) {
	if (!instance.name) {
		return Fields.addressLine1(instance.addressLine1);
	}
	return Fields.name(instance.name);
}

export function information(
	instance: Omit<AddressInformationFragment, "country"> & {
		country?: CountryNameFragment | null;
	},
) {
	let info = Fields.addressLine1(instance.addressLine1);
	if (instance.addressLine2) {
		info += " " + Fields.addressLine2(instance.addressLine2);
	}
	info += ", " + Fields.city(instance.city);
	if (instance.stateOrProvince) {
		info += ", " + Fields.stateOrProvince(instance.stateOrProvince);
	}
	if (instance.postalCode) {
		info += ", " + Fields.postalCode(instance.postalCode);
	}
	if (instance.country) {
		info += ", " + CountryFormat.name(instance.country);
	}
	return info;
}
